<template>
    <div class="select-richtext" :class="classes">
        <span class="typographies-paragraph-small-semibold">{{ label }}</span>
        <CompassIcon size="extra-small" icon="caret-down" :disabled="disabled" />
    </div>
</template>

<script>
export default {
    name: 'SelectRichText',

    props: {
        label: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'select-richtext--active': this.active,
                'select-richtext--disabled': this.disabled,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.select-richtext {
    display: flex;
    padding: var(--spacing-0);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-0);
    border-radius: var(--spacing-0);

    &:hover:not(.select-richtext--disabled) {
        cursor: pointer;
        background: var(--colors-common-background-primary-hover-alt);
    }

    &--active {
        background: var(--colors-common-background-primary-active-alt);
    }

    &--disabled {
        color: var(--colors-common-text-standard-disabled);
    }
}
</style>
